// frontend/src/utils/substituteTriggers.js

// Decide how prominently to surface the substitute affordance for one flower.
//  - 'unavailable': no vendor pick AND the date-window search came back empty.
//  - 'over-min'   : a pick exists but the order needs < half a box, so the
//                   vendor min-order/box forces significant waste.
//  - null         : resting state — show the quiet affordance, no emphasis.
// `boxSize` is the picked offer's unit_count (stems per box); 0/unknown disables
// the over-min check. `neededStems` is stems-per-arrangement × arrangement qty.
const WASTE_THRESHOLD = 0.5;

export function substituteEmphasis({ hasPick, noOffersForDate, neededStems, boxSize }) {
  if (!hasPick && noOffersForDate) return 'unavailable';
  if (
    hasPick &&
    Number(boxSize) > 0 &&
    Number(neededStems) > 0 &&
    Number(neededStems) < Number(boxSize) * WASTE_THRESHOLD
  ) {
    return 'over-min';
  }
  return null;
}
